import styled, { css } from 'styled-components';
import {
  CardHeader,
  Snackbar,
  ThemedComponent,
  Typography,
} from '@la/ds-ui-components';
import { media } from 'lib/media-queries/mixins';

export const PlayerRegistrationContainer = styled.div`
  width: 100%;
  max-width: 920px;
`;

export const PlayerDetailsFormDescription = styled(Typography).attrs({
  size: 'medium',
  variant: 'ui',
  weight: 'medium',
})`
  margin-bottom: 16px;
`;

export const InputGroupContainer = styled.div<{ $gap?: number }>`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 12px;

  ${({ $gap }) => {
    return media.TabletLandscapeUp`
      flex-direction: row;
      margin-bottom: ${$gap ? `${$gap}px` : '12px'}
      align-items: flex-start;
    `;
  }}
`;

export const InputContainer = styled.div<{ $columnSpan?: 1 | 2 }>`
  grid-column: 1 / span 2;

  ${({ $columnSpan }) => {
    return css`
      ${media.TabletLandscapeUp`
        grid-column: ${$columnSpan === 2 ? '1 / span 2' : 'auto'};
      `}
    `;
  }}
`;

export const TextInputContainer = styled.div<{ $columnSpan?: 1 | 2 }>`
  grid-column: 1 / span 2;
  width: 100%;
  margin-bottom: 0;

  & label {
    word-break: break-word;
    white-space: normal;
    text-align: left;
  }

  ${({ $columnSpan }) => {
    return css`
      ${media.TabletLandscapeUp`
        padding-top: 4px;
        margin-bottom: 4px;
        grid-column: ${$columnSpan === 2 ? '1 / span 2' : 'auto'};
      `}
    `;
  }}
`;

export const AddressDetailsInputGroupContainer = styled(InputGroupContainer)`
  & > div:nth-child(2) {
    flex: 0 0 25%;
  }
  & > div:nth-child(3) {
    flex: 0 0 25%;
  }
`;

export const EntriesContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
});

export const FieldEntry = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
});

export const InfoCardHeader = styled(CardHeader)`
  display: flex;
  justify-content: space-between;
`;

export const IconContainer = styled.div<ThemedComponent>(
  ({ theme }: ThemedComponent) => {
    return {
      '& svg': {
        fill: theme.semantic?.secondary[500],
      },

      '&::hover': {
        cursor: 'pointer',
      },
    };
  }
);

export const EditButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const DatePickerContainer = styled.div`
  width: 100%;
  ${media.TabletLandscapeUp`
    margin-top: 28px;
  `}
`;

export const PlayerDetail = styled.div`
  display: flex;
  flex-direction: column;

  ${media.TabletPortraitUp`
    flex-direction: row;
    gap: 8px;
  `}
`;

export const PlayerDetailLabel = styled(Typography)`
  flex-basis: 30%;

  ${media.TabletPortraitUp`
    flex-basis: 35%;
    margin-bottom: 8px;    
  `}
`;
export const PlayerDetailValue = styled(Typography)`
  margin-bottom: 8px;
`;

export const PlayerDetailsSnackbar = styled(Snackbar)`
  margin-bottom: 92px;

  ${media.TabletPortraitUp`
    margin-bottom: 72px;
  `}
`;
